export default "__VITE_ASSET__BEW30pNZ__"